import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ResourceList, Stack, TextAlpha } from '@yonderland/andes-react';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useProductDetailContext } from '../../../containers/product/ProductDetailV2Container';
import { analyticsActions } from '../../../redux/analytics/actions/AnalyticsActions.creators';
import { AdditionalProductSelectorProduct } from './AdditionalProductSelectorProduct';
export const AdditionalProductSelector = ({ additionalProductSelector }) => {
    const { selectedAdditionalProducts, setSelectedAdditionalProducts } = useProductDetailContext();
    const dispatch = useDispatch();
    const { additionalProducts } = additionalProductSelector;
    useEffect(() => {
        (additionalProducts === null || additionalProducts === void 0 ? void 0 : additionalProducts.length) > 0 && dispatch(analyticsActions.additionalProductSelector(additionalProducts));
    }, [additionalProducts]);
    if ((additionalProducts === null || additionalProducts === void 0 ? void 0 : additionalProducts.length) <= 0) {
        return null;
    }
    const handleSelectionChange = (_event, product) => {
        setSelectedAdditionalProducts(product);
    };
    return (_jsxs(Stack, { direction: "col", gap: "2", children: [additionalProductSelector.title && _jsx(TextAlpha, { strong: true, children: additionalProductSelector.title }), additionalProducts && (_jsx(ResourceList, { testId: "additional_product_selector", items: additionalProducts, hasCheckbox: true, selectable: true, selectedItems: selectedAdditionalProducts, onSelectionChange: handleSelectionChange, renderItem: (additionalProduct, index) => (_jsx(AdditionalProductSelectorProduct, Object.assign({}, additionalProduct), index)) }))] }));
};
